import Hero from "../components/home/Hero";
import Trust from "../components/home/Trust";
import FeaturedProperties from "../components/home/FeaturedProperties";
import HiRiseProjects from "../components/home/HiRiseProjects";
import TopLocations from "../components/home/TopLocations";
import Testimonials from "../components/home/Testimonials";
import HowItWorks from "../components/home/HowItWorks";
import CTABanner from "../components/home/CTABanner";
import Agents from "../components/home/Agents";
import Footer from "../components/layout/Footer";
const Home = () => {
  return (
    <>
      <Hero />
      <Trust />
      <FeaturedProperties />
      <HiRiseProjects />
      <TopLocations />
      <Testimonials />
      <HowItWorks />
      <CTABanner />
      <Agents />
    </>
  );
};

export default Home;
